import { Tooltip, Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import { Cancel, CheckCircleRounded } from '@mui/icons-material';
import SituacaoAnalise, { SITUACAO_ANALISE } from '@/dominio/SituacaoAnalise';
import DataUtil from '@/util/DataUtil';
import { green, grey, red } from '@mui/material/colors';
class ValidacaoPreSessao extends ReactComponent {
    carregando = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregando: observable,
            tipoValidacao: computed,
            informacoesValidacao: computed,
            inicializarEstadoValidacao: action,
            handleToggleValidacao: action
        });
    }

    get tipoValidacao() {
        if (this.observableProps.registro?.necessitaImportacaoSalaSessao) {
            return null;
        }
        const tipo =
            this.observableProps.registro?.informacaoProcessoSalaSessao?.tipoValidacao ||
            SITUACAO_ANALISE.SEM_VALIDACAO.id;
        const situacao = Object.values(SITUACAO_ANALISE).find((item) => item.id === tipo);
        return situacao || SITUACAO_ANALISE.SEM_VALIDACAO;
    }

    get informacoesValidacao() {
        const { nomeUsuarioValidacao, dataValidacao } = this.observableProps.registro.informacaoProcessoSalaSessao;
        let textoInformacoesValidacao = `Situação atual: ${this.tipoValidacao?.descricao}`;
        if (nomeUsuarioValidacao) {
            textoInformacoesValidacao += `\nAutor da última alteração: ${nomeUsuarioValidacao}`;
        }
        if (dataValidacao) {
            textoInformacoesValidacao += `\nData da última alteração: ${DataUtil.formatarData(dataValidacao)}`;
        }
        return textoInformacoesValidacao;
    }

    componentDidMount() {
        this.inicializarEstadoValidacao();
    }

    inicializarEstadoValidacao = () => {
        this.validacao =
            this.observableProps.registro?.informacaoProcessoSalaSessao?.tipoValidacao ||
            SITUACAO_ANALISE.SEM_VALIDACAO.id;
    };

    handleToggleValidacao = async (novaValidacao) => {
        this.openModal = false;
        this.carregando = true;
        const resultado = await this.validacaoPreSessaoService.analisarSituacaoProcesso(
            this.observableProps.registro.sessaoId,
            this.observableProps.registro.numeroProcesso,
            novaValidacao
        );
        runInAction(() => {
            this.observableProps.registro.informacaoProcessoSalaSessao.tipoValidacao = novaValidacao;
            if (resultado.nomeUsuarioValidacao) {
                this.observableProps.registro.informacaoProcessoSalaSessao.nomeUsuarioValidacao =
                    resultado.nomeUsuarioValidacao;
            }
            if (resultado.dataValidacao) {
                this.observableProps.registro.informacaoProcessoSalaSessao.dataValidacao = resultado.dataValidacao;
            }
            this.carregando = false;
        });
        const descricaoSituacao = SituacaoAnalise.getDescricao(novaValidacao);
        this.mensagemStore.abrirMensagemSucesso(
            `Processo marcado como ${descricaoSituacao.toLowerCase()} com sucesso.`
        );
    };

    render() {
        const isPendente = this.tipoValidacao?.id === SITUACAO_ANALISE.PENDENTE.id;
        const isValidado = this.tipoValidacao?.id === SITUACAO_ANALISE.VALIDADO.id;

        return (
            this.tipoValidacao && (
                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '32px', marginLeft: '8px' }}>
                        <ToggleButtonGroup
                            disabled={this.carregando}
                            aria-label="Validação de Processo"
                            exclusive
                            value={this.tipoValidacao}
                            onChange={(e, novaValidacao) => this.handleToggleValidacao(novaValidacao)}
                            sx={{
                                height: '32px',
                                borderRadius: '8px',
                                '& .MuiToggleButtonGroup-firstButton': {
                                    borderRadius: '8px 0 0 8px'
                                },
                                '& .MuiToggleButtonGroup-lastButton': {
                                    borderRadius: '0 8px 8px 0'
                                }
                            }}
                        >
                            <Tooltip
                                title={
                                    isValidado ? (
                                        <Box sx={{ whiteSpace: 'pre-line' }}>{this.informacoesValidacao}</Box>
                                    ) : (
                                        'Validar'
                                    )
                                }
                                placement="top"
                            >
                                <Box>
                                    <ToggleButton
                                        value={SITUACAO_ANALISE.VALIDADO.id}
                                        sx={{
                                            px: 1,
                                            py: '3px',
                                            borderRadius: '0 16px 16px 0',
                                            border: isValidado ? `1px solid ${green[100]}` : `1px solid ${grey[300]}`,
                                            backgroundColor: isValidado ? green[100] : grey[200],
                                            verticalAlign: 'top'
                                        }}
                                    >
                                        <CheckCircleRounded
                                            style={{
                                                color: isValidado ? SITUACAO_ANALISE.VALIDADO.cor : 'gray'
                                            }}
                                        />
                                    </ToggleButton>
                                </Box>
                            </Tooltip>
                            <Tooltip
                                title={
                                    isPendente ? (
                                        <Box sx={{ whiteSpace: 'pre-line' }}>{this.informacoesValidacao}</Box>
                                    ) : (
                                        'Marcar como pendente'
                                    )
                                }
                                placement="top"
                            >
                                <Box>
                                    <ToggleButton
                                        value={SITUACAO_ANALISE.PENDENTE.id}
                                        sx={{
                                            px: 1,
                                            py: '3px',
                                            border: isPendente ? `1px solid ${red[100]}` : `1px solid ${grey[300]}`,
                                            backgroundColor: isPendente ? red[100] : grey[200],
                                            verticalAlign: 'top'
                                        }}
                                    >
                                        <Cancel
                                            style={{
                                                color: isPendente ? SITUACAO_ANALISE.PENDENTE.cor : 'gray'
                                            }}
                                        />
                                    </ToggleButton>
                                </Box>
                            </Tooltip>
                        </ToggleButtonGroup>
                    </Box>
                </Box>
            )
        );
    }
}

export default inject('stores')(observer(ValidacaoPreSessao));
